(function () {
  function init(root) {
    var sectionId = root.getAttribute('data-section-id');
    var grid = root.querySelector('#PGrid-' + sectionId);
    if (!grid) return;

    var loadBtn = root.querySelector('.pgrid__load');
    var pager = root.querySelector('[data-pgrid-pagination]');
    var sentinel = root.querySelector('[data-pgrid-sentinel]');
    var status = root.querySelector('[data-pgrid-status]');
    var filterBtns = Array.prototype.slice.call(root.querySelectorAll('.pgrid__filter'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-panel-for]'));

    // With the "All" pill off the section opens on the first category, so the
    // starting tag comes from the pill the section marked active, not a constant.
    var activeBtn = filterBtns.filter(function (b) { return b.classList.contains('is-active'); })[0] || filterBtns[0];
    var currentTag = activeBtn ? activeBtn.getAttribute('data-tag') : 'all';
    var hasAllPill = filterBtns.some(function (b) { return b.getAttribute('data-tag') === 'all'; });
    var currentPage = parseInt(grid.dataset.currentPage || '1', 10);
    var totalPages = parseInt(grid.dataset.totalPages || '1', 10);
    var loadingAll = false;
    var autoLoad = !!sentinel && typeof IntersectionObserver === 'function';
    var autoBusy = false;
    var observer = null;

    // Collection mode renders the union of several collections in one pass, which
    // Liquid's paginate cannot span. Those grids ship every card and reveal them in
    // page-size batches instead of fetching — same button, no round-trip.
    var clientPaged = grid.dataset.clientPaged === 'true';
    var pageSize = parseInt(grid.dataset.pageSize || '8', 10) || 8;
    var revealed = pageSize;

    function items() {
      return Array.prototype.slice.call(grid.querySelectorAll('.pgrid__item'));
    }

    function matches(item) {
      var tags = (item.getAttribute('data-tags') || '').split(/\s+/);
      return currentTag === 'all' || tags.indexOf(currentTag) !== -1;
    }

    function matchCount() {
      return items().filter(matches).length;
    }

    function applyFilter() {
      var shown = 0;
      items().forEach(function (item) {
        if (!matches(item)) { item.hidden = true; return; }
        shown += 1;
        item.hidden = clientPaged && shown > revealed;
      });
      syncAsideHeight();
    }

    // The rail squares off with the first product row. Row height is content-driven
    // (grid-auto-rows: 1fr), so it has to be measured rather than declared.
    var aside = root.querySelector('.pgrid__aside');

    function syncAsideHeight() {
      if (!aside) return;
      var first = items().filter(function (item) { return !item.hidden; })[0];
      if (!first) {
        aside.style.removeProperty('--pgrid-aside-h');
        return;
      }
      var h = Math.round(first.getBoundingClientRect().height);
      if (h > 0) aside.style.setProperty('--pgrid-aside-h', h + 'px');
    }

    function syncPanel() {
      if (!panels.length) return;
      panels.forEach(function (panel) {
        var on = panel.getAttribute('data-panel-for') === currentTag;
        panel.hidden = !on;
        panel.classList.toggle('is-active', on);
      });
    }

    function updateLoadBtn() {
      if (clientPaged) {
        if (!loadBtn) return;
        loadBtn.hidden = autoLoad || revealed >= matchCount();
        return;
      }
      if (pager) {
        pager.hidden = currentPage >= totalPages;
        return;
      }
      if (!loadBtn) return;
      if (autoLoad) {
        loadBtn.hidden = true;
        return;
      }
      loadBtn.hidden = currentTag !== 'all' || currentPage >= totalPages;
    }

    function announce(msg) {
      if (status) status.textContent = msg;
    }

    function pageUrl(page) {
      var params = new URLSearchParams(window.location.search);
      params.set('section_id', sectionId);
      params.set('page', String(page));
      return window.location.pathname + '?' + params.toString();
    }

    function fetchPage(page) {
      return fetch(pageUrl(page), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newItems = doc.querySelectorAll('#PGrid-' + sectionId + ' .pgrid__item');
          newItems.forEach(function (item) { grid.appendChild(item); });
          currentPage = page;
        });
    }

    function ensureAllLoaded() {
      if (loadingAll || currentPage >= totalPages) return Promise.resolve();
      loadingAll = true;
      if (loadBtn) loadBtn.setAttribute('aria-busy', 'true');
      var chain = Promise.resolve();
      for (var p = currentPage + 1; p <= totalPages; p++) {
        (function (page) { chain = chain.then(function () { return fetchPage(page); }); })(p);
      }
      return chain.finally(function () {
        loadingAll = false;
        if (loadBtn) loadBtn.removeAttribute('aria-busy');
      });
    }

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        filterBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        currentTag = btn.getAttribute('data-tag');
        revealed = pageSize;
        syncPanel();
        var done = clientPaged || currentTag === 'all' ? Promise.resolve() : ensureAllLoaded();
        done.then(function () { applyFilter(); updateLoadBtn(); });
      });
    });

    if (loadBtn) {
      loadBtn.addEventListener('click', function () {
        if (clientPaged) {
          revealed += pageSize;
          applyFilter();
          updateLoadBtn();
          return;
        }
        if (currentPage >= totalPages) { updateLoadBtn(); return; }
        loadBtn.setAttribute('aria-busy', 'true');
        fetchPage(currentPage + 1).then(function () {
          applyFilter();
          updateLoadBtn();
          loadBtn.removeAttribute('aria-busy');
        });
      });
    }

    if (autoLoad) {
      observer = new IntersectionObserver(
        function (entries) {
          if (!entries.some(function (e) { return e.isIntersecting; })) return;
          if (autoBusy || loadingAll) return;
          if (clientPaged) {
            if (revealed >= matchCount()) { observer.disconnect(); return; }
            revealed += pageSize;
            applyFilter();
            updateLoadBtn();
            announce('Showing ' + Math.min(revealed, matchCount()) + ' products');
            return;
          }
          if (currentPage >= totalPages) { observer.disconnect(); return; }
          autoBusy = true;
          fetchPage(currentPage + 1)
            .then(function () {
              applyFilter();
              updateLoadBtn();
              announce('Showing ' + items().length + ' products');
              if (currentPage >= totalPages) {
                observer.disconnect();
                return;
              }
              observer.unobserve(sentinel);
              observer.observe(sentinel);
            })
            .finally(function () { autoBusy = false; });
        },
        { rootMargin: '800px 0px' }
      );
      observer.observe(sentinel);
    }

    syncPanel();
    syncAsideHeight();
    if (aside && typeof ResizeObserver === 'function') {
      var pending = false;
      new ResizeObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; syncAsideHeight(); });
      }).observe(grid);
    } else if (aside) {
      window.addEventListener('resize', syncAsideHeight);
    }
    if (clientPaged) {
      applyFilter();
      updateLoadBtn();
    } else if (!hasAllPill && currentTag !== 'all') {
      // Server-paged and opening on a category: the later pages have to be in the
      // DOM before the first filter pass, or the grid shows a partial category.
      ensureAllLoaded().then(function () { applyFilter(); updateLoadBtn(); });
    } else {
      updateLoadBtn();
    }
  }

  function boot() {
    document.querySelectorAll('[data-collection-grid]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
